
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="bg-gradient-to-br from-[#14B8A6] to-[#0F9B8E] text-white py-16">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center">
          <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium mb-6">
            2026年最新版｜学生・29歳以下限定特典あり
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            学生・29歳以下におすすめの<br className="md:hidden" />クレジットカード
          </h1>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
            初めてのクレジットカードでも安心。学生や29歳以下の方限定の特典が充実した、審査に通りやすいカードを厳選してご紹介します。
          </p>
          
          {/* 赤色CTAボタン */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <a
              href="#ranking"
              className="inline-block bg-[#DC2626] hover:bg-[#B91C1C] text-white px-10 py-4 rounded-lg font-bold text-lg transition-all cursor-pointer whitespace-nowrap shadow-lg"
            >
              おすすめカードを今すぐ見る（PR）
            </a>
            <Link
              to="/diagnosis"
              className="inline-block bg-white/20 hover:bg-white/30 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all cursor-pointer whitespace-nowrap border-2 border-white/50"
            >
              あなたに合うカード診断
            </Link>
          </div>

          {/* 信頼性バッジ */}
          <div className="flex flex-wrap justify-center gap-4 text-white/90 text-sm">
            <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full">
              <i className="ri-shield-check-line text-[#FFD700]"></i>
              <span>年会費無料</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full">
              <i className="ri-user-star-line text-[#FFD700]"></i>
              <span>学生限定特典</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full">
              <i className="ri-check-double-line text-[#FFD700]"></i>
              <span>審査通りやすい</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
